import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, createTextVNode as _createTextVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-980df5a4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "abstract-terminal-header" }
const _hoisted_2 = { class: "action-cntr cm-ui-mb15" }
const _hoisted_3 = { class: "abstract-terminal-desc" }
const _hoisted_4 = {
  key: 0,
  class: "desc-cntr"
}
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "red-txt" }, "*", -1))
const _hoisted_6 = { class: "red-txt" }
const _hoisted_7 = {
  key: 1,
  class: "desc-cntr"
}
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "red-txt" }, "*", -1))
const _hoisted_9 = { class: "red-txt" }
const _hoisted_10 = { class: "port-list-tip-count" }

import { computed, reactive, ref, nextTick, watch } from 'vue'
import { useCmTableListRefresh } from '@/hooks/use-cm-table-list-refresh'
import { useReflectiveInjector, Type } from '@tanbo/vue-di-plugin'
import { useI18n } from 'vue-i18n'
import CmTable from '@/components/cmTable/index.vue'
import type { TableOpt } from '@/components/cmTable/types'
import {
  QueryParams,
  TerminalItem,
  BlockRuleParams,
  ResetBlockRuleParams
} from '@/views/dashboard/manage/port-manage/_components/port-view/_components/port-block-drawer.service'
import { TableDataRowState, TableState } from '@/services/table-memory-pagination'
import { ElMessage } from 'element-plus'
import {
  AbstractTerminalViewService,
  BlockQueryParams
} from '@/views/dashboard/manage/port-manage/_components/abstract-terminal-view/abstract-terminal-view.service'
import type { PortBlockDrawerService } from '@/views/dashboard/manage/port-manage/_components/port-view/_components/port-block-drawer.service'
import type { BlockViewDrawerService } from '@/views/dashboard/manage/port-manage/_components/block-view/_components/block-view-drawer.service'
import type { PortItem } from '@/views/dashboard/manage/port-manage/_components/port-view/port-view.service'
import type { BlockPortItem } from '@/views/dashboard/manage/port-manage/_components/block-view/block-view.service'
import { formatTableEmpty } from '@/utils/format'
import { PermissionFe } from '@/services/service-permission.service'
import { TerminalAuthStatus } from '@/views/dashboard/_enum/terminal-auth-status'
import { computerInfoCols } from '@/views/dashboard/data-safe/ransomware-protection/types/ransomware-incident'
import UnauthorizedTooltip from '@/views/dashboard/_components/unauthorized-tooltip/unauthorized-tooltip.vue'
import CmTableSelectionTipBar from '@/views/dashboard/_components/cmtable-selection-tip-bar/cmtable-selection-tip-bar.vue'

/** 与原先 el-table sortable="custom" 一致：计算机名、分组、终端状态 */
type TerminalDrawerListService = PortBlockDrawerService | BlockViewDrawerService


export default /*#__PURE__*/_defineComponent({
  __name: 'abstarct-terminal-view',
  props: {
    needAuth: { type: Boolean, default: false }
  },
  emits: ["closePortTerminal"],
  setup(__props: any, { emit: __emit }) {

const SORTABLE_PROPS = new Set(['computer_name', 'group_name', 'login_status'])

function isDisabled(row: TerminalItem & { auth_status?: number }) {
  return row.auth_status !== undefined && row.auth_status !== TerminalAuthStatus.normal
}

const props = __props

const emit = __emit

const { t, locale } = useI18n()
const injector = useReflectiveInjector()
/** 具体为 PortBlockDrawerService / BlockViewDrawerService；基类仅保留 TableMemoryPagination，业务方法在子类中以普通方法实现 */
const service = injector.get(AbstractTerminalViewService as Type<AbstractTerminalViewService>) as TerminalDrawerListService

function syncServiceIsDisabled() {
  service.isDisabled = props.needAuth
    ? (row: TerminalItem) => isDisabled(row as TerminalItem & { auth_status?: number })
    : () => false
}
syncServiceIsDisabled()
watch(() => props.needAuth, syncServiceIsDisabled)

const tableRef = ref<{ getList: (isKeepPage?: boolean) => Promise<unknown> } | null>(null)
const { refreshList } = useCmTableListRefresh(tableRef)

const listForm = reactive({
  ...service.getQueryParams(),
  ...(props.needAuth ? { permission_name: PermissionFe.port_control as string } : {})
}) as Record<string, unknown> & QueryParams & Partial<BlockQueryParams>

const viewData = ref({
  tableData: [] as TableDataRowState<TerminalItem>[],
  state: {} as TableState<TableDataRowState<TerminalItem>>,
  total: 0,
})

const selectItemRef = ref(service.getSelectItem())

const lastCmSelection = ref<TableDataRowState<TerminalItem>[]>([])
const syncingFromService = ref(false)

function pullServiceState() {
  const state = service.getViewState()
  viewData.value.state = state
  viewData.value.tableData = state.data.list
  viewData.value.total = state.data.total
  selectItemRef.value = service.getSelectItem()
  nextTick(syncCmTableSelectionFromService)
}

function listDataFormate(rows: TableDataRowState<TerminalItem>[] = []) {
  const selectAll = service.getViewState().selectAll
  for (const row of rows) {
    if (selectAll && !service.isDisabled(row)) {
      row.$selected = true
    }
  }
  return rows
}

function syncCmTableSelectionFromService() {
  const elTable = (tableRef.value as any)?.tableRef
  if (!elTable) return
  syncingFromService.value = true
  elTable.clearSelection()
  viewData.value.tableData.forEach((row) => {
    if (row.$selected) {
      elTable.toggleRowSelection(row, true)
    }
  })
  lastCmSelection.value = viewData.value.tableData.filter((r) => r.$selected)
  nextTick(() => {
    syncingFromService.value = false
  })
}

function onChangeSelected(selection: TableDataRowState<TerminalItem>[]) {
  if (syncingFromService.value) {
    lastCmSelection.value = selection.slice()
    return
  }
  const prev = new Set(lastCmSelection.value.map((r) => r.device_id))
  const curr = new Set(selection.map((r) => r.device_id))
  let toggled: TableDataRowState<TerminalItem> | undefined
  for (const r of selection) {
    if (!prev.has(r.device_id)) {
      toggled = r
      break
    }
  }
  if (!toggled) {
    for (const r of lastCmSelection.value) {
      if (!curr.has(r.device_id)) {
        toggled = r
        break
      }
    }
  }
  if (toggled) {
    service.mergeSelectedData(service.getSelectedData(), toggled)
  } else {
    service.mergeSelectedData(selection)
  }
  pullServiceState()
}

function handleCheckbox(row: TableDataRowState<TerminalItem>) {
  service.mergeSelectedData(service.getSelectedData(), row)
  pullServiceState()
}

function tipBarSelectedCount() {
  if (viewData.value.state.selectAll) return viewData.value.state.selectCount
  return viewData.value.tableData.filter((r) => r.$selected).length
}

function rowSelectable(row: TableDataRowState<TerminalItem>) {
  return !(props.needAuth && isDisabled(row as TerminalItem & { auth_status?: number }))
}

function handleTipSelect(type: 'all' | 'reverse') {
  const rows = viewData.value.tableData
  const enabled = rows.filter((r) => rowSelectable(r))
  if (type === 'all') {
    service.mergeSelectedData(enabled)
  } else {
    for (const r of enabled) {
      service.mergeSelectedData(service.getSelectedData(), r)
    }
  }
  pullServiceState()
}

function pageSelectAllChecked(rows: TableDataRowState<TerminalItem>[]) {
  const enabled = rows.filter((r) => rowSelectable(r))
  return enabled.length > 0 && enabled.every((r) => r.$selected)
}

function pageSelectAllIndeterminate(rows: TableDataRowState<TerminalItem>[]) {
  const enabled = rows.filter((r) => rowSelectable(r))
  return enabled.some((r) => r.$selected) && !enabled.every((r) => r.$selected)
}

function pageHeaderAllDisabled() {
  if (!viewData.value.tableData.length) return true
  return props.needAuth && !viewData.value.tableData.some((r) => rowSelectable(r))
}

function handlePageSelectAllHeader(rows: TableDataRowState<TerminalItem>[], checked: boolean) {
  const enabled = rows.filter((r) => rowSelectable(r))
  if (checked) {
    service.mergeSelectedData(enabled)
  } else {
    service.mergeSelectedData([])
  }
  pullServiceState()
}

function calcSelectAllScopeDisabled() {
  if (!viewData.value.total || viewData.value.state.selectAll) return true
  if (props.needAuth) {
    return !viewData.value.tableData.some((r) => rowSelectable(r))
  }
  return false
}


async function getData() {
  await nextTick()
  await refreshList()
}

async function selectAll() {
  listForm.page = 1
  listForm.useMemory = false
  service.selectAll()
  pullServiceState()
  await getData()
}

async function selectCancel() {
  listForm.useMemory = false
  service.cancelSelectAll()
  pullServiceState()
  await getData()
}

function mapPartialToTableColumn(col: ReturnType<typeof computerInfoCols>[number]) {
  const baseOpt = { ...(col.columnOpt || col.colOpt || {}) }
  if (col.prop === 'user_mark') {
    return {
      prop: col.prop,
      label: col.label,
      width: col.width,
      showOverflow: col.showOverflow,
      type: col.type,
      formatter: (row: TerminalItem, value: unknown, column: unknown) => formatTableEmpty(row, column, value),
      columnOpt: baseOpt
    }
  }
  return {
    prop: col.prop,
    label: col.label,
    width: col.width,
    showOverflow: col.showOverflow,
    type: col.type,
    columnOpt: baseOpt
  }
}

const tableOpt = computed((): TableOpt => {
  void locale.value
  void viewData.value.state.selectAll
  const base = computerInfoCols(false, false, t, { mac: false }).map(mapPartialToTableColumn)
  return {
    showTip: false,
    selection: false,
    rowKey: 'device_id',
    path: 'list',
    totalPath: 'total',
    usePagination: false,
    disableScrollLoad: false,
    bodyStyle: 'height: 100%;padding: 10px 16px',
    height: '100%',
    containerOpt: { style: { flex: '1', minHeight: 0, overflow: 'hidden' } },
    columns: [
      {
        prop: '__sel',
        label: '',
        width: 52,
        columnOpt: { fixed: 'left', align: 'center' }
      },
      ...base,
      {
        prop: 'process_name',
        label: t('portManage.listenProcess'),
        columnOpt: { minWidth: 150 }
      },
      {
        prop: 'login_status',
        label: t('menu.terminalStatus'),
        columnOpt: { sortable: 'custom', width: 110 },
        formatter: (row: TerminalItem) =>
          row.login_status === 1 ? t('deviceStatus.online') : t('deviceStatus.offline')
      }
    ]
  }
})

async function listApi(params: Record<string, unknown>) {
  Object.assign(listForm, {
    page: params.page,
    limit: 20
  })
  if (params.sort !== undefined) {
    listForm.sort = params.sort as string
  }
  if (params.asc !== undefined) {
    listForm.asc = params.asc as boolean
  }
  await service.refresh(listForm as QueryParams & BlockQueryParams)
  pullServiceState()
  return {
    list: viewData.value.tableData,
    total: viewData.value.total
  }
}

function addBlock() {
  const port_num = (service.getQueryParams() as QueryParams).port_num
  const system_type = (selectItemRef.value as PortItem).system_type
  const params: BlockRuleParams = {
    system_types: [system_type],
    select_type: 0,
    device_list: [] as string[],
    port_start: port_num,
    port_end: port_num,
    port_list: [{ port: port_num, system_type }],
  }
  if (viewData.value.state.selectAll) {
    params.select_type = 2
  } else {
    params.device_list = service.getSelectedData().map((item) => item.device_id)
  }
  service.addBlockRule(params).then(() => {
    ElMessage.success(t('portManage.blockSuccess'))
    emit('closePortTerminal')
  }).catch(() => {
    ElMessage.error(t('portManage.blockFailed'))
  })
}

function resetBlock() {
  const ruleId = (service.getQueryParams() as BlockQueryParams).rule_id
  const params: ResetBlockRuleParams = {
    system_types: [(selectItemRef.value as PortItem).system_type],
    select_type: 0,
    device_list: [] as string[],
    rule_id_list: ruleId != null ? [ruleId] : [],
  }
  if (viewData.value.state.selectAll) {
    params.select_type = 1
  } else {
    params.device_list = service.getSelectedData().map((item) => item.device_id)
  }
  service.resetBlockRule(params).then(() => {
    ElMessage.success(t('portManage.relieveSuccess'))
    emit('closePortTerminal')
  }).catch(() => {
    ElMessage.error(t('portManage.relieveFailed'))
  })
}

function blockPort() {
  (service.getQueryParams() as BlockQueryParams).rule_id ? resetBlock() : addBlock()
}

const headerAction = computed(() => {
  const s = selectItemRef.value as PortItem | BlockPortItem
  if ('rule_id' in s && s.rule_id) {
    return {
      isReset: true,
      portStart: s.port_start,
      portEnd: s.port_end,
      portNum: 0
    }
  }
  const p = s as PortItem
  return {
    isReset: false,
    portStart: 0,
    portEnd: 0,
    portNum: p.port_num
  }
})

return (_ctx: any,_cache: any) => {
  const _component_i18n_t = _resolveComponent("i18n-t")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_checkbox = _resolveComponent("el-checkbox")!

  return (_openBlock(), _createBlock(CmTable, {
    ref_key: "tableRef",
    ref: tableRef,
    modelValue: listForm,
    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((listForm) = $event)),
    "table-opt": tableOpt.value,
    api: listApi,
    "data-formate": listDataFormate,
    "page-option": { pageNumName: 'page', pageSizeName: 'limit' },
    "first-loading": true,
    onChangeSelected: onChangeSelected
  }, {
    header: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            (headerAction.value.isReset)
              ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                  _createVNode(_component_i18n_t, {
                    keypath: "portManage.abstractTerminalUnblockDesc",
                    tag: "span"
                  }, {
                    asterisk: _withCtx(() => [
                      _hoisted_5
                    ]),
                    portRange: _withCtx(() => [
                      _createElementVNode("span", _hoisted_6, _toDisplayString(`${headerAction.value.portStart} ~ ${headerAction.value.portEnd}`), 1)
                    ]),
                    _: 1
                  })
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_7, [
                  _createVNode(_component_i18n_t, {
                    keypath: "portManage.abstractTerminalBlockDesc",
                    tag: "span"
                  }, {
                    asterisk: _withCtx(() => [
                      _hoisted_8
                    ]),
                    portNum: _withCtx(() => [
                      _createElementVNode("span", _hoisted_9, _toDisplayString(headerAction.value.portNum), 1)
                    ]),
                    _: 1
                  })
                ]))
          ]),
          _createVNode(_component_el_button, {
            type: "primary",
            disabled: !viewData.value.state.selectCount,
            size: "small",
            onClick: blockPort
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(headerAction.value.isReset ? _unref(t)('portManage.abstractTerminalConfirmRelieve') : _unref(t)('portManage.confirmBlock')), 1)
            ]),
            _: 1
          }, 8, ["disabled"])
        ]),
        _createVNode(CmTableSelectionTipBar, {
          "bar-height": 34,
          "action-align": "left"
        }, {
          summary: _withCtx(() => [
            _createVNode(_component_i18n_t, {
              keypath: "portManage.tipSelectedTerminalsTotal",
              tag: "span",
              class: "port-list-tip-bar__summary"
            }, {
              count: _withCtx(() => [
                _createElementVNode("span", _hoisted_10, _toDisplayString(tipBarSelectedCount()), 1)
              ]),
              _: 1
            })
          ]),
          actions: _withCtx(() => [
            _createVNode(_component_el_button, {
              type: "text",
              class: "cm-btn-text",
              disabled: !viewData.value.tableData.length || viewData.value.state.selectAll,
              onClick: _cache[0] || (_cache[0] = ($event: any) => (handleTipSelect('all')))
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t('portManage.pageSelectAll')), 1)
              ]),
              _: 1
            }, 8, ["disabled"]),
            _createVNode(_component_el_button, {
              type: "text",
              class: "cm-btn-text",
              disabled: !viewData.value.tableData.length || viewData.value.state.selectAll,
              onClick: _cache[1] || (_cache[1] = ($event: any) => (handleTipSelect('reverse')))
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t('sensitiveFileScanning.reversePage')), 1)
              ]),
              _: 1
            }, 8, ["disabled"]),
            _createVNode(_component_el_button, {
              type: "text",
              class: "cm-btn-text",
              disabled: calcSelectAllScopeDisabled(),
              onClick: selectAll
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t('portManage.selectAllTerminals')), 1)
              ]),
              _: 1
            }, 8, ["disabled"]),
            _createVNode(_component_el_button, {
              type: "text",
              class: "cm-btn-text",
              disabled: !viewData.value.tableData.some((item) => item.$selected) && !viewData.value.state.selectAll,
              onClick: selectCancel
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t('sensitiveFileScanning.cancelSelect')), 1)
              ]),
              _: 1
            }, 8, ["disabled"])
          ]),
          _: 1
        })
      ])
    ]),
    "__sel-header": _withCtx(() => [
      _createVNode(_component_el_checkbox, {
        "model-value": pageSelectAllChecked(viewData.value.tableData),
        disabled: !viewData.value.tableData.length || viewData.value.state.selectAll || pageHeaderAllDisabled(),
        indeterminate: pageSelectAllIndeterminate(viewData.value.tableData),
        onChange: _cache[2] || (_cache[2] = (v) => handlePageSelectAllHeader(viewData.value.tableData, !!v))
      }, null, 8, ["model-value", "disabled", "indeterminate"])
    ]),
    __sel: _withCtx(({ row }) => [
      (_ctx.needAuth)
        ? (_openBlock(), _createBlock(UnauthorizedTooltip, {
            key: 0,
            "permission-key": _unref(PermissionFe).port_control,
            "device-id": row.device_id,
            "auth-status": (row as TerminalItem & { auth_status?: number }).auth_status,
            onAuthSuccess: _cache[3] || (_cache[3] = () => void _unref(refreshList)())
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_checkbox, {
                "model-value": row.$selected,
                disabled: viewData.value.state.selectAll || isDisabled(row as TerminalItem & { auth_status?: number }),
                onChange: () => handleCheckbox(row)
              }, null, 8, ["model-value", "disabled", "onChange"])
            ]),
            _: 2
          }, 1032, ["permission-key", "device-id", "auth-status"]))
        : (_openBlock(), _createBlock(_component_el_checkbox, {
            key: 1,
            "model-value": row.$selected,
            disabled: viewData.value.state.selectAll,
            onChange: () => handleCheckbox(row)
          }, null, 8, ["model-value", "disabled", "onChange"]))
    ]),
    _: 1
  }, 8, ["modelValue", "table-opt"]))
}
}

})